import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import useCustomSearchParams from "../../../utils/useCustomSearchParams.js";
import { toast } from "react-toastify";
import ICONS from "../../../assets/Icons/index.js";
import PrimaryButton from "../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";
import CommonAssignLabelPopup from "../../../components/_utils/CommonPopups/CommonAssignLabelPopup/index.jsx";

import TopNavComponent from "../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import CommonTransactionApprovalCard from "../../../components/_utils/CommonTransactionApprovalCard/index.jsx";
import FormatAmount from "../../../components/_utils/FormatAmount/FormatAmount.js";
import PaginationComponent from "../../../components/_utils/PaginationComponent/index.jsx";

import Loader from "../../../components/Loader/Index.jsx";
import { beneCategories } from "../../../redux/features/beneficiary/beneAllVerification/beneAllVerification.js";
import { checkUsertoken } from "../../../redux/features/login/login.js";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import {
  getOwnerAccBalance,
  setshowsuccestoast,
} from "../../../redux/features/owner/ownerAllVerification/ownerAllVerification.js";
import { getRefreshTokenNew } from "../../../redux/features/refreshToken/refreshToken.js";
import {
  errorcode,
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
  RejectReasonLength,
  TimelineBarConfiguration,
} from "../../../utils/configurationProvider.js";

import CommonToast from "../../../components/_utils/CommonToast/index.jsx";

import SmallPopupWithInput from "../../../components/_utils/CommonSmallPopupWithInput/index.jsx";
import TEXT from "../../../utils/globalText.js";

import {
  addNewLabelRequest,
  removeNewLabelRequest,
  reimbursementRequestApproval,
  ReimbursementRequestDeniedApproval,
  reimbursementRequestDetails,
  reimbursementRequestViewAll,
  ReimbursementRequestWaitingApproval,
} from "../../../redux/features/reimbursementRequest/index.js";
import ReimbursementAccountDetailsPopup from "../../../components/_utils/ReimbursementAccountDetailsPopup/index.jsx";
import UniversalRefreshToast from "../../../components/_utils/UniversalRefreshToast/index.jsx";
import TimelinePopupContent from "../../../components/_utils/TimelinePopupContent/index.jsx";
import LargePopupRedirect from "../../../components/_utils/CommonPopups/CommonLargePopupRedirect/index.jsx";
import ReimbursementTxnDetailsPopup from "../../../components/ReimbursementRequest/ReimbursementReqTxnDetailsPopup/index.jsx";
import ReimbursementReqTxnDetailsPopup from "../../../components/ReimbursementRequest/ReimbursementReqTxnDetailsPopup/index.jsx";
import {
  approveFieldForceRequest,
  getAllFieldForceRequest,
  getSpecificFieldForceRequest,
  FieldForceRequestDeniedApproval,
  addFieldForceLabelRequest,
} from "../../../redux/features/fieldForceRequest/index.js";
import FieldForceAccountDetailsPopup from "../../../components/_utils/FieldForceAccountDetailsPopup/index.jsx";

const ApprovalGreen = ICONS.APPROVED_GREEN_LINEAR;
const CloseGreyCircleIcon = ICONS.CLOSE_WITH_GREY_CIRCLE;
const QueuedIcon = ICONS.QUEUED;
const confidential_transaction = ICONS.CONFIDENTIAL_TRANSACTION;

const DeclinedRed = ICONS.REJECTED_RED;
const PendingIcons = ICONS.PENDING;
const FailedToAction = ICONS.ERROR_WITH_WHITE_OUTLINED_CIRCLE;

const FieldForceTxnRequestSingleApproval = () => {
  const dispatch = useDispatch();
  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const location = useLocation();
  const { searchParam, handleSearchParams } = useCustomSearchParams({
    pageno: GlobalConfiguration.lengthCheckOne,
    pagesize: dropdownOptions[0],
  });

  const [page, setPage] = useState(
    Number(searchParam.get("pageno")) || GlobalConfiguration.lengthCheckOne,
  );
  const labelActionDispatchedRef = useRef(false);
  const [showPopup, setShowPopup] = useState(false);
  const [deniedId, SetdeniedId] = useState(null);
  const [declineReason, setDeclineReason] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [doneBinding, setDoneBinding] = useState(false);
  const [loading, setLoading] = useState({});
  const [openRequestpopup, setopenRequestpopup] = useState(false);
  const [currentAccountDetails, setcurrentAccountDetails] = useState({
    bankAccountName: "",
    beneAccountId: "",
    bankAccountIFSC: "",
    bankAccountNo: "",
    categories: "",
    amount: "",
    settleType: "",
    bankLogo: "",
    pan: "",
    ownerId: null,
    ownerAccountName: "",
    ownerBankIFSC: null,
    ownerBankBalance: GlobalConfiguration.lengthCheckZero,
    ownerBankLogo: null,
    ownerLastUpdated: null,
    ownerBankAccountNo: null,
    selectedCategory: null,
    mergeCategory: null,
    amountInWords: "",
    labels: [],
    ownerLabels: [],
    comment: "",
    date: "",
    expenseType: "",
    description: "",
    uploadFile: "",
  });
  const Navigate = useNavigate();
  const [isDrawerOpen, setisDrawerOpen] = useState(false);
  const [BeneTxnDetailsId, SetBeneTxnDetailsId] = useState("");
  const [refreshAnimation, setrefreshAnimation] = useState("");
  const [inputDisabled, setInputDisabled] = useState(false);
  const [pageSize, setPageSize] = useState(
    searchParam.get("pagesize") || PaginationConfiguration.paginationSmall,
  );
  const [selectedValue, setSelectedValue] = useState(
    searchParam.get("pagesize") || PaginationConfiguration.paginationSmall,
  );
  const [AllReimburseTxnAccounts, setAllReimburseTxnAccounts] = useState([]);
  const [allBeneTxnAccountsLoading, setAllBeneTxnAccountsLoading] =
    useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const [filterCat, setFilterCat] = useState(false);
  const [PrevBalance, setPrevBalance] = useState(null);
  const [initCategory, setInitCategory] = useState("");
  const [label, setlabel] = useState(searchParam.get("category") || "");
  const [showTxnDetailPop, setShowTxnDetailPop] = useState(false);
  const [txnId, setTxnId] = useState(null);
  const [currentCategory, setCurrentCategory] = useState(
    searchParam.get("category") || "",
  );
  const [ShowFilterErrorPage, setShowFilterErrorPage] = useState(false);
  const filterRef = useRef(null);
  const filterBGRef = useRef(null);
  const filterParentDivRef = useRef(null);

  const [mainData, setMainData] = useState([]);

  const [openRecreateModel, setopenRecreateModel] = useState(false);

  const [isLabelPopupOpen, setisLabelPopupOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [filteredData, setfilteredData] = useState([]);
  const [txnlabels, settxnLabels] = useState([]);
  const [labeltxnid, setLabeltxnid] = useState([]);
  const [btnClicked, setbtnClicked] = useState({});
  const [selectedLabels, setSelectedLabels] = useState([]);
  const [RequestId, setRequestId] = useState("");
  const [toggle, setToggle] = useState(false);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const cardRefs = useRef({});
  const [timelineTxnDetails, setTimelineTxnDetails] = useState([]);

  // FilteredSearchField states
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [active, setActive] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const [inputData, setInputData] = useState([]);
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [showApprovalTimeline, setShowApprovalTimeline] = useState(false);

  const [currentBtnClicked, setCurrentBtnClicked] = useState({});

  const { ownerAccBalanceLoading, ownerAccBalanceError } = useSelector(
    (state) => state.ownerAllVerification,
  );
  const navigate = useNavigate();
  const [opentimelinepopup, SetopenTimelinePopup] = useState(false);
  const [openApprovalTimeline, setOpenApprovalTimeline] = useState([]);

  const { reimbursementRequestApprovalData } = useSelector(
    (state) => state.reimbursementRequest,
  );
  const services = useSelector((state) => state.refreshToken.services);

  const loginid = JSON.parse(sessionStorage.getItem("response"));

  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);
  const { reimbursementRequestDetailsData } = useSelector(
    (s) => s.reimbursementRequest,
  );

  const handleSubmit = (key, value) => {
    handleSearchParams(key, value);
  };

  const handleInputChange = (event) => {
    const value = event.target.value;

    const sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");

    const limitedValue = sanitizedValue.slice(
      GlobalConfiguration.lengthCheckZero,
      RejectReasonLength.lengthOfDecline,
    );

    setDeclineReason(limitedValue);
  };

  const showLoadingToast = (txt) => {
    CommonToast({
      text: txt,
      icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
      variant: "var(--processing)",
      buttonNeeded: false,
      btnProps: {
        enabledBgColor: "var(--primary-bg)",
        enabledTextColor: "var(--text-primary)",
        btnText: "",
        handleFunction: () => {},
        icon: "",
        btnType: "button",
        isDisabled: false,
        hoverOption: "white",
      },
    });
  };

  const handleReject = async (id, reason) => {
    try {
      if (
        services?.find((service) => service === "AFieldForceRequest") ===
        undefined
      ) {
        Navigate("/feature_not_assigned", {
          state: { unavailableService: "AFieldForceRequest" },
        });
        return;
      }

      if (!sessionStorage.getItem("q2p_token")) {
        dispatch(checkUsertoken());
        return;
      }

      setShowLoader(true);
      setInputDisabled(true);

      dispatch(checkUsertoken());
      showLoadingToast("Rejecting request.");

      const result = await dispatch(
        FieldForceRequestDeniedApproval({
          id,
          AccountIdData: declineReason,
        }),
      );

      const payload = result?.payload;

      // wait for loader animation
      await new Promise((resolve) =>
        setTimeout(resolve, IntervalConfiguration.intervalExtraLarge),
      );

      if (payload?.errors?.user_unauthorized?.[0]) {
        Navigate("/feature_not_assigned", {
          state: { unavailableService: "AFieldForceRequest" },
        });
        return;
      }

      const updatedData = AllReimburseTxnAccounts.map((item) => {
        if (item.request_id !== id) return item;

        const tx = payload?.requests?.[0];
        let lifecycleStatus = "error";
        let errorMessage = "";

        if (payload?.status === true) {
          lifecycleStatus =
            tx?.lifecycle_status === "rejected"
              ? "rejected"
              : tx?.lifecycle_status === "pending"
                ? "pendingOne"
                : "error";
        }

        if (payload?.errors?.base?.[0]?.errors) {
          errorMessage = payload.errors.base[0].errors[0];
        } else if (payload?.errors?.base?.[0]) {
          errorMessage = payload.errors.base[0];
        }

        return {
          ...item,
          lifecycle_status:
            item.lifecycle_status === "pending" && payload?.status === true
              ? lifecycleStatus
              : "error",
          rejected: true,
          rejection_reason: reason,
          error: payload?.status === false ? "true" : "false",
          message: payload?.status === false ? errorMessage : "",
        };
      });

      updateAllTxn(updatedData);

      if (payload?.status === false) {
        CommonToast({
          text:
            payload?.errors?.base?.[0]?.errors?.[0] ||
            payload?.errors?.base?.[0] ||
            "Error occurred",
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
        setDeclineReason("");
      } else {
        CommonToast({
          text: "Request rejected successfully.",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
          buttonNeeded: false,
        });

        setShowPopup(false);
        setDeclineReason("");
      }
    } catch (error) {
      console.error("Reject txn failed:", error);

      CommonToast({
        text: "Something went wrong. Please try again.",
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    } finally {
      setShowLoader(false);
      setInputDisabled(false);
      setCurrentBtnClicked((c) => {
        return {
          ...c,
          [id]: "none",
        };
      });
    }
  };

  const fetchSearchDropdownData = async () => {
    setLoadingData(true);

    if (active === "Category") {
      const res = await dispatch(
        beneCategories({ search_string: searchUserTextDebounce }),
      );

      const categories = res?.payload?.categories || [];

      setInputData(
        categories.map((c) => ({
          id: c.name,
          Category: c.name,
          Description: c.description || "Not given",
        })),
      );
    }
    setTimeout(() => {
      setLoadingData(false);
    });
  };

  const handleClearFilters = () => {
    setCurrentCategory("");
    setSearchUserTextDebounce("");
    setSelectedLabels([]);
    setlabel("");
    setPage(GlobalConfiguration.lengthCheckOne);
    navigate(
      {
        pathname: location.pathname,
        search: `?pageno=${GlobalConfiguration.lengthCheckOne}&pagesize=${dropdownOptions[0]}`,
      },
      { replace: true },
    );
  };

  useEffect(() => {
    if (active) fetchSearchDropdownData();
  }, [active]);

  useEffect(() => {
    // dispatch(getRefreshTokenNew());
    onMount();
  }, [page, pageSize, currentCategory, markerData]);

  useEffect(() => {
    if (isLabelPopupOpen) {
      const availableLabels = JSON.parse(
        sessionStorage.getItem("AvailableLabelsRequest") || "[]",
      );
      settxnLabels(availableLabels);
    }
  }, [isLabelPopupOpen]);

  const onMount = () => {
    setAllBeneTxnAccountsLoading(true);
    dispatch(checkUsertoken());
    // dispatch(getRefreshTokenNew());
    dispatch(
      approveFieldForceRequest({
        page_no: page,
        page_size: pageSize,
        category: currentCategory ?? undefined,
      }),
    )
      .then((response) => {
        const newData = (response?.payload?.requests || []).map((account) => ({
          ...account,
          loading: false,
          error: "false",
          message: "",
          last_updated_user_id_check: "false",
          distribution_lifecycle_status: "",
        }));

        setAllReimburseTxnAccounts(newData);
        setMainData(response?.payload);
        setfilteredData(response?.payload?.requests ?? []);
        setAllBeneTxnAccountsLoading(false);
      })

      .catch(() => {
        setAllBeneTxnAccountsLoading(false);
      });
  };

  useEffect(() => {
    dispatch(enableSwitcher());
    return () => {
      dispatch(disableSwitcher());
    };
  }, []);

  const handleClose = () => {
    setisLabelPopupOpen(false);
    if (labelActionDispatchedRef.current) {
      onMount();
      dispatch(getAllFieldForceRequest());
      labelActionDispatchedRef.current = false;
    }
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setAllBeneTxnAccountsLoading(true);
    dispatch(checkUsertoken());
    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const recordIds = toArray(labeltxnid);
    const res = await dispatch(
      addFieldForceLabelRequest({
        record_ids: recordIds,
        labels: labelsToAssign,
      }),
    );
    if (addFieldForceLabelRequest.fulfilled.match(res)) {
      toast.dismiss();
      CommonToast({
        text: "Labels assigned successfully.",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await onMount();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (addFieldForceLabelRequest.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setAllBeneTxnAccountsLoading(false);
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setAllBeneTxnAccountsLoading(true);
    dispatch(checkUsertoken());
    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const recordIds = toArray(labeltxnid);
    const res = await dispatch(
      removeNewLabelRequest({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );
    if (removeNewLabelRequest.fulfilled.match(res)) {
      toast.dismiss();
      CommonToast({
        text: "Labels unassigned successfully.",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await onMount();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (removeNewLabelRequest.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setAllBeneTxnAccountsLoading(false);
    if (removeNewLabelRequest?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleOpenPopup = (id) => {
    setShowPopup(true);
    SetdeniedId(id);
  };
  const handleClosePopup = () => {
    setShowPopup(false);
    setDeclineReason("");
  };

  const openBeneTxnDetailModal = () => {
    setShowTxnDetailPop(true);
  };

  const handlePagination = (pageNum) => {
    setPage(pageNum);
    handleSearchParams("pageno", pageNum);
  };

  const closeBeneTxnDetailModal = () => {
    setShowTxnDetailPop(false);
  };
  const closeBeneAccountDetailModal = () => {
    setisDrawerOpen(false);
  };

  const handleMultiViewClick = () => {
    CommonToast({
      text: "Feature coming soon",
      icon: "https://q2pay.in/new_assets/common/detail_page/info.svg",
      variant: "var(--coming-soon)",
      buttonNeeded: false,
    });
  };

  const SideDrawerOpen = async (id, txnId) => {
    SetBeneTxnDetailsId(id);
    setisDrawerOpen(!isDrawerOpen);
  };

  const PopupcloseIcons = () => {
    SetopenTimelinePopup(false);
    setShowApprovalTimeline(false);
  };

  const handleApprovalTimeline = (index) => {
    setOpenApprovalTimeline((prevOpenDivs) => {
      if (!Array.isArray(prevOpenDivs)) {
        return [];
      }
      const newOpenDivs = [...prevOpenDivs];
      newOpenDivs[index] = !newOpenDivs[index];
      return newOpenDivs;
    });

    if (!openApprovalTimeline[index]) {
      setTimeout(() => {
        cardRefs.current[index]?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, IntervalConfiguration.intervalExtraSmall);
    }
  };

  const renderApprovalData = (obj) => {
    return Object.keys(obj).map((key, index, array) => {
      const isLastItem =
        index === array.length - GlobalConfiguration?.lengthCheckZero;
      if (key !== "action") {
        return (
          <>
            <div
              key={key}
              className={`flex flex-row items-center ${
                !isLastItem ? "mb-margin-md" : ""
              }`}
            >
              <div className="w-icon-xs border-b-border border-solid border-text-secondary"></div>

              <p
                key={key}
                className="w-width-full text-text-secondary text-sm text-left font-normal ml-margin-xs make-first-letter-small break-words"
              >{`"${key}": "${obj[key]}"`}</p>
            </div>
          </>
        );
      }
      return null;
    });
  };

  const updateAllTxn = (updatedTxn) => {
    setAllReimburseTxnAccounts(updatedTxn);
  };

  const handleFilterCategory = () => {
    setCurrentCategory(label);
    setAllReimburseTxnAccounts([]);
    if (page === GlobalConfiguration.lengthCheckOne) {
      setAllBeneTxnAccountsLoading(true);
    }

    setInitCategory(false);
    setFilterOpen(false);
    setFilterCat(false);
  };
  const handleSelect = (value) => {
    setSelectedValue(value);
    setPageSize(value);
    const nextPage = Number(page) || GlobalConfiguration.lengthCheckOne;
    setPage(nextPage);
    handleSearchParams("pagesize", value);
    handleSearchParams("pageno", nextPage);
  };

  const hasAnyFilter =
    (currentCategory &&
      currentCategory.length > GlobalConfiguration.lengthCheckZero) ||
    (searchUserTextDebounce &&
      searchUserTextDebounce.length > GlobalConfiguration.lengthCheckZero);

  const noTransactionsFromAPI =
    !allBeneTxnAccountsLoading &&
    mainData &&
    mainData.total_count === GlobalConfiguration.lengthCheckZero &&
    !hasAnyFilter;

  const noResultsAfterFilter =
    !allBeneTxnAccountsLoading &&
    AllReimburseTxnAccounts.length === GlobalConfiguration.lengthCheckZero &&
    hasAnyFilter;

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter" && filterOpen) {
        handleFilterCategory();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [label, selectedLabels, filterOpen]);

  useEffect(() => {
    const handleFilter = (e) => {
      if (
        filterBGRef.current &&
        filterBGRef.current.contains(e.target) &&
        filterParentDivRef.current &&
        !filterParentDivRef.current.contains(e.target)
      ) {
        setFilterOpen(false);
      }
    };

    document.addEventListener("click", handleFilter);

    return () => {
      document.removeEventListener("click", handleFilter);
    };
  }, [filterBGRef, filterRef]);

  useEffect(() => {
    if (label === "") {
      setCurrentCategory("");
    }
  }, [label]);

  useEffect(() => {
    if (ownerAccBalanceLoading) {
      UniversalRefreshToast();
    }
    if (!ownerAccBalanceLoading && !ownerAccBalanceError) {
      setTimeout(() => {
        toast.dismiss();
      }, IntervalConfiguration.intervalExtraSmall);
    }
  }, [ownerAccBalanceLoading]);

  useEffect(() => {}, [reimbursementRequestApprovalData]);
  const hasAccountApprovalAccess = services?.includes("AFieldForceRequest");
  const getTxnOverlayConfig = ({
    account,
    loading,
    openTxn,
    openAccountDrawer,
    openTxn2,
  }) => {
    const isError =
      account.lifecycle_status === "error" &&
      account.error === "true" &&
      !loading[account.request_id];

    const isRejected =
      account.lifecycle_status === "rejected" &&
      account.error === "false" &&
      !loading[account.request_id];

    const isAccountApprovalPending =
      account.lifecycle_status === "pending" &&
      account.field_force_account_approval_status === "pending" &&
      !loading[account.request_id];

    const isTxnApprovalPending =
      (account.lifecycle_status === "pending" || loading[account.request_id]) &&
      account.field_force_account_approval_status === "approved";

    if (isError) {
      return {
        cardState: "single",
        overlay1Icon: FailedToAction,
        overlay1Text: "Failed to take action",
        overlay1Subtext: account.message,
        overlay1CtaText: "View request",
        overlay1CtaOnClick: openTxn,
        overlay1Cta1Color: "var(--negative-act)",
        allowApproveReject: false,
      };
    } else if (isRejected) {
      return {
        cardState: "double",
        overlay1Icon: DeclinedRed,
        overlay1Text: "Rejected",
        overlay1Subtext: "This request has been rejected.",
        overlay1CtaText: "View request",
        overlay1CtaOnClick: openTxn,
        overlay2Text: account.rejection_reason,
        overlay2Subtext: "Rejected reason",
        allowApproveReject: false,
      };
    } else if (isAccountApprovalPending) {
      return {
        cardState: "single",
        overlay1Icon: null,
        overlay1Text: "Account approval pending",
        overlay1Subtext:
          "Account is not approved, please approve account before approving request.",
        overlay1CtaText: "Approve account",
        overlay1CtaOnClick: () => {
          if (hasAccountApprovalAccess) {
            openAccountDrawer();
          } else {
            navigate("/feature_not_assigned", {
              state: { unavailableService: "BAAccount, BVAccount" },
            });
          }
        },

        allowApproveReject: false,
      };
    } else if (isTxnApprovalPending) {
      return {
        cardState: "default",
        allowApproveReject: services?.includes("AFieldForceRequest"),
      };
    } else {
      return {
        cardState: "default",
        allowApproveReject: false,
      };
    }
  };

  const OpenTimeline = async (id) => {
    SetopenTimelinePopup(true);
    setShowApprovalTimeline(true);
    dispatch(checkUsertoken());

    const details = await dispatch(getSpecificFieldForceRequest(id));

    if (details?.payload?.request) {
      let request = structuredClone(details.payload.request[0]);
      request.statusName =
        details.payload.request[0]?.lifecycle_status === "pending"
          ? "Require approval"
          : "pending";
      request.statusColor =
        details.payload.request[0]?.lifecycle_status === "pending"
          ? "text-pending"
          : "text-text-primary";

      setTimelineTxnDetails([request]);
    }
  };

  return (
    <>
      {!(
        noTransactionsFromAPI ||
        noResultsAfterFilter ||
        allBeneTxnAccountsLoading
      ) && (
        <div className="fixed w-full bottom-bottom-base z-z-index-tooltip">
          {showInnerSearchBar && (
            <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header"></div>
          )}
          <PaginationComponent
            handleSelect={handleSelect}
            selectedValue={selectedValue}
            data={mainData}
            pageSize={pageSize}
            dropdownOptions={dropdownOptions}
            handlePagination={handlePagination}
            currentPage={page}
            setIsOpen={setIsOpen}
          />
        </div>
      )}

      {/* {opentimelinepopup && (
        <div className="fixed top-top_base left-left_base w-width-full h-height_full flex items-center bg-PopUp_BackDrop justify-center z-z_index_modal bg-opacity-dark_opacity">
          <LargePopupRedirect
            headerTitle="Request timeline"
            headerFontWeight="semibold"
            headerFontColor="text_primary"
            headertextSize="font_md"
            closeiconenabledBgColor="var(--primary_nav)"
            closeiconisLoading={false}
            closeiconhandleFunction={PopupcloseIcons}
            closeicon="https://q2pay.in/new_assets/common/create_flow/close.svg"
            closeiconhoverOption="white"
            closeiconbtnType="button"
            closeiconisDisabled={false}
            closeicondisabledBgColor=""
            closeiconbuttonRef={null}
            closeicontitle="Close"
            btnType="button"
            handleFunction={() => {}}
            enabledBgColor="var(--positive_act)"
            hoverOption="dark"
            outLineColor=""
            enabledTextColor="var(--text_primary)"
            fullWidthRequired={false}
            isDisabled={false}
            disabledTextColor=""
            disabledBgColor=""
            isLoading={false}
            buttonRef={null}
            inActiveVariantNeeded={false}
            isLoaderNeeded={false}
            isscrollRequired={true}
          >
            <TimelinePopupContent
              viewInternalTxnDetails={timelineTxnDetails}
              // handleOnclick={handleTimelinePopup}
              showDistributionRightIcon={false}
              showApprovalLeftIcon={false}
              showApprovalTimeline={showApprovalTimeline}
              openApprovalTimeline={openApprovalTimeline}
              handleApprovalTimeline={handleApprovalTimeline}
              renderApprovalData={renderApprovalData}
              setOpenApprovalTimeline={setOpenApprovalTimeline}
              hasDistributionData={false}
              type="schedule"
            />
          </LargePopupRedirect>
        </div>
      )} */}

      {/* {openRequestpopup && (
        <div
          className="fixed top-top_base left-left_base w-full_width h-full_height z-z_index_modal bg-PopUp_BackDrop bg-opacity-dark_opacity"
          onClick={() => {
            setopenRequestpopup(false);
          }}
        >
          <ReimbursementReqTxnDetailsPopup
            reimburse_request_id={RequestId}
            closePopup={() => {
              setopenRequestpopup(false);
            }}
            RequestHeader={"Request details"}
            type={"reimbursereq_details"}
          />
        </div>
      )} */}

      {isDrawerOpen && (
        <div
          className="fixed top-top-base left-left-base w-full-width h-full-height z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity"
          onClick={() => {
            closeBeneAccountDetailModal();
          }}
        >
          <FieldForceAccountDetailsPopup
            field_force_account_id={BeneTxnDetailsId}
            closeBeneAccountDetailModal={closeBeneAccountDetailModal}
            // servicesType="BenAdmin"
          />
        </div>
      )}

      {showPopup && (
        <div className="fixed top-top-base left-left-base w-full h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal">
          {" "}
          <SmallPopupWithInput
            headerTitle={TEXT.REJECT_REASON_LABEL}
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderTitle={
              "Please state the reason for rejecting the request."
            }
            secondHeaderFontWeight="normal"
            secondHeaderFontColor="text-secondary"
            secondHeaderTextSize="font-xs"
            inputPlaceholder={TEXT.REASON_10_150_CHAR}
            inputVariant={
              declineReason &&
              declineReason.length > GlobalConfiguration.accountnormalLength
                ? "verified"
                : declineReason &&
                    declineReason.length <
                      GlobalConfiguration.owneraccountnormalLength
                  ? "typing"
                  : "default"
            }
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              if (!showLoader) {
                handleInputChange(e);
              }
            }}
            inputValue={declineReason}
            inputFontKind="small"
            inputIsFullWidth={true}
            btnOneText={TEXT.CANCEL}
            btnOneHandleFunction={() => {
              setCurrentBtnClicked((c) => {
                return {
                  ...c,
                  [deniedId]: "none",
                };
              });
              if (!showLoader) {
                handleClosePopup();
              }
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnOneIsDisabled={showLoader}
            btnTwoText={TEXT.REJECT}
            btnTwoHandleFunction={() => {
              if (
                !declineReason ||
                declineReason.length <
                  GlobalConfiguration.owneraccountnormalLength ||
                showLoader
              ) {
                return;
              }
              handleReject(deniedId, declineReason);
              handleClosePopup();
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              !declineReason ||
              declineReason.length <
                GlobalConfiguration.owneraccountnormalLength
            }
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={showLoader ? true : false}
            btnTwoIsLoading={showLoader ? true : false}
            btnTwoHoverOption="black"
            btnTwoInActiveVariantNeeded={true}
          />
        </div>
      )}

      <div className="flex flex-col w-width-full h-screen bg-primary-bg pb-pagination-height">
        <div className="w-width-full hidden Qsmd:block h-navbar-breadcrumb-height bg-primary-nav flex-shrink-0"></div>
        <div className="flex flex-col items-center justify-center shadow-box-shadow-bottom bg-primary-nav w-full-width z-z-index-overlay relative">
          <TopNavComponent
            topNavCtaBtn1Needed={false}
            topNavCtaBtn1Props={undefined}
            handleBack={() => navigate(GlobalConfiguration.navigate_back)}
            topNavCtaBtn2Needed={false}
            BottomHeader={undefined}
            isSelectionView={false}
            isToggleNeeded={true}
            toggleProps={{
              state: true,
              title: "Multi approval",
              isDisabled: showSearchBar,

              handleClick: () =>
                navigate(
                  "/field_force_transaction_dashboard/field_force_request_multi_approval",
                ),
            }}
            assignLabelNeeded={false}
            assignTagNeeded={false}
            filteredSearchProps={{
              setShowInnerSearchBar: setShowInnerSearchBar,
              showSearchBar: showSearchBar,
              isSearchDisabled: allBeneTxnAccountsLoading,
              onSearchInput: (val) => setSearchUserTextDebounce(val),
              searchText: searchUserTextDebounce,
              searchPlaceholder: "Search request",
              filterPlaceholder: "Category / Labels",
              filterItems: [
                {
                  name: "Category",
                  short_name: "Cat",
                  isMulti: false,
                  value: currentCategory,
                  setValue: (val) => {
                    setPage(GlobalConfiguration.lengthCheckOne);
                    setCurrentCategory(val);
                    handleSubmit("category", val);
                  },
                  isDropdown: true,
                },
              ],
              isSearchClearAllDisabled: !currentCategory?.length,
              inputData: inputData,
              active: active,
              setActive: setActive,
              loading: allBeneTxnAccountsLoading,
              loadingData: loadingData,
              setLoading: setLoadingData,
              isShowSortBy: false,
              isShowFilter: false,
            }}
          />
        </div>

        <div className="flex-1 overflow-y-auto overflow-x-hidden w-width-full flex justify-center pb-padding-xl Qsmd:pb-padding-base relative">
          {showInnerSearchBar && (
            <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header"></div>
          )}
          <div className="flex flex-col gap-gap-md py-padding-md w-width-full px-padding-md Qlg:px-padding-base overflow-y-auto">
            {allBeneTxnAccountsLoading ? (
              <div className="w-width-full  h-full flex items-center justify-center">
                <Loader />
              </div>
            ) : noTransactionsFromAPI ? (
              <div className="w-full flex flex-col items-center justify-center text-center gap-gap-md m-auto">
                <div>
                  <img
                    src={
                      "https://q2pay.in/new_assets/graphics/no_data/no_pending_transaction.svg"
                    }
                    alt="no-pending-transaction"
                  />
                </div>
                <p className="text-sm text-text-primary">
                  There are no more transactions that require <br /> your
                  approval.
                </p>
                <PrimaryButton
                  enabledBgColor="var(--primary-nav-act)"
                  btnText="Go to dashboard"
                  hoverOption="white"
                  btnType="button"
                  handleFunction={() =>
                    navigate("/field_force_transaction_dashboard")
                  }
                  enabledTextColor="var(--text-primary)"
                />
              </div>
            ) : noResultsAfterFilter ? (
              <div className="w-full flex flex-col items-center justify-center text-center gap-gap-md m-auto">
                <div>
                  <img
                    src="https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg"
                    alt="no data found"
                  />
                </div>
                <p className="text-sm text-text-primary">No data found.</p>
                <PrimaryButton
                  enabledBgColor="var(--primary-nav-act)"
                  btnText="Clear parameters"
                  hoverOption="white"
                  btnType="button"
                  handleFunction={() => {
                    handleClearFilters();
                  }}
                  enabledTextColor="var(--text-primary)"
                />
              </div>
            ) : (
              reimbursementRequestApprovalData === undefined ||
              AllReimburseTxnAccounts?.map((account) => {
                const overlay = getTxnOverlayConfig({
                  account,
                  loading,
                  openTxn: () => {
                    CommonToast({
                      text: "Feature coming soon",
                      icon: "https://q2pay.in/new_assets/common/detail_page/info.svg",
                      variant: "var(--coming-soon)",
                      buttonNeeded: false,
                    });
                  },
                  openAccountDrawer: () =>
                    SideDrawerOpen(
                      account.field_force_account_id,
                      account.request_id,
                    ),
                });

                const alerts = [];

                /**
                 * @type {import("../../../components/_utils/CommonTransactionApprovalCard/index.jsx").Entry[][]}
                 */
                const entries = [
                  [
                    {
                      type: "textSubtext",
                      text: `INR ${FormatAmount({ price: account?.amount || "0" })}`,
                      subText: "Amount",
                      textColor: "var(--settled)",
                      isBold: true,
                    },
                    {
                      type: "textSubtext",
                      text: account?.field_force_account_name

                        ?.toLowerCase()
                        ?.split(" ")
                        ?.map(
                          (word) =>
                            word
                              .charAt(GlobalConfiguration.lengthCheckZero)
                              .toUpperCase() +
                            word.slice(GlobalConfiguration.lengthCheckOne),
                        )
                        ?.join(" "),
                      subText: "Account name",
                    },
                    {
                      type: "textSubtext",
                      text: account?.category || "unavailable",
                      subText: "Category",
                    },
                  ],
                ];

                return (
                  <div
                    key={account.txn_id}
                    className="mx-auto flex Qlg:flex-row flex-col Qlg:max-w-[var(--tab-width-normal)] w-width-full z-z-index-content"
                  >
                    <CommonTransactionApprovalCard
                      overrideAutoLoader
                      whichBtnClicked={
                        currentBtnClicked?.[account.request_id] ?? "none"
                      }
                      accountApprovalPending={
                        account.lifecycle_status === "pending" &&
                        account.field_force_account_approval_status ===
                          "pending" &&
                        !loading[account.txn_id]
                      }
                      entries={entries}
                      alerts={alerts}
                      cardState={overlay.cardState}
                      overlay1Text={overlay.overlay1Text}
                      overlay1SubtextColor={
                        account.field_force_account_approval_status ===
                        "pending"
                          ? "var(--pending)"
                          : "var(--text-primary)"
                      }
                      overlay1Subtext={overlay.overlay1Subtext}
                      overlay1CtaText={overlay.overlay1CtaText}
                      overlay1CtaOnClick={overlay.overlay1CtaOnClick}
                      overlay1Cta1Color={overlay?.overlay1Cta1Color}
                      overlay2Text={overlay.overlay2Text}
                      overlay2Subtext={overlay.overlay2Subtext}
                      approveClick={() => {
                        // CommonToast({
                        //   text: "Feature coming soon",
                        //   icon: "https://q2pay.in/new_assets/common/detail_page/info.svg",
                        //   variant: "var(--coming-soon)",
                        //   buttonNeeded: false,
                        // });
                        if (services?.includes("AFieldForceRequest")) {
                          const updatedAccountDetails = {
                            request_id: account?.request_id,
                            bankAccountName: account?.beneficiary_account_name,
                            beneAccountId: account?.beneficiary_account_id,
                            bankAccountIFSC:
                              account?.beneficiary_account_ifsc_code,
                            bankAccountNo:
                              account?.beneficiary_account_bank_acc_no,
                            categories: account?.category,
                            amount: account?.requested_amount,
                            settleType: account?.payment_method,
                            bankLogo: account?.beneficiary_account_ifsc_code,
                            pan: "",
                            ownerId: null,
                            ownerAccountName: "",
                            ownerBankIFSC: null,
                            ownerBankBalance:
                              GlobalConfiguration.lengthCheckZero,
                            ownerBankLogo: null,
                            ownerLastUpdated: null,
                            ownerBankAccountNo: null,
                            selectedCategory: {
                              configuration: account?.additional_data,
                            },
                            mergeCategory: account?.additional_data?.data,
                            amountInWords: "",
                            labels: account?.labels || [],
                            ownerLabels: [],
                            comment: "",
                            date: account?.reimbursement_date,
                            expenseType: account?.expense_type,
                            description:
                              currentAccountDetails?.description ?? "",
                            uploadFile: account?.uploaded_file_data,
                            uploadURL: account?.uploaded_file_url,
                          };
                          setcurrentAccountDetails(updatedAccountDetails);
                          navigate(
                            "/field_force_transaction_dashboard/create_field_force_transaction",
                            {
                              state: {
                                ...updatedAccountDetails,
                                type: "PayReimburseTxn",
                                flow: "PayReimburseTxn",
                                TypeRTGS: "RequestRTGS",
                              },
                            },
                          );
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "AFieldForceRequest",
                            },
                          });
                        }
                      }}
                      rejectClick={() => {
                        setCurrentBtnClicked((c) => {
                          return { ...c, [account.request_id]: "reject" };
                        });

                        if (hasAccountApprovalAccess) {
                          handleOpenPopup(account.request_id);
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "AFieldForceRequest",
                            },
                          });
                        }
                      }}
                      approveBtnText="Approve and pay"
                      rejectBtnText={
                        <>
                          Reject
                          <br />
                          request
                        </>
                      }
                      DestinationNotRequired={true}
                      createdByRequired={true}
                      createdOnSubtext={"Created on"}
                      createdOnText={account?.created_on}
                      createdByText={account?.created_by_name}
                      createdOnRequired={true}
                      destinationAccountNumber={
                        account?.field_force_account_bank_acc_no
                      }
                      destinationAccountIfsc={
                        account?.field_force_account_ifsc_code
                      }
                      destinationAccountNumberSubtext="Destination account"
                      destinationAccountText={
                        account?.field_force_account_ifsc_code
                      }
                      destinationAccountSubtext="IFSC code"
                      ctaBtn1Text="Field force details"
                      ctaBtn1OnClick={() => {
                        // setopenRequestpopup(true);
                        // setRequestId(account?.request_id);
                        CommonToast({
                          text: "Feature coming soon",
                          icon: "https://q2pay.in/new_assets/common/detail_page/info.svg",
                          variant: "var(--coming-soon)",
                          buttonNeeded: false,
                        });
                      }}
                      ctaBtn2Text="Additional details"
                      ctaBtn2OnClick={() => {
                        // OpenTimeline(account?.request_id);
                        CommonToast({
                          text: "Feature coming soon",
                          icon: "https://q2pay.in/new_assets/common/detail_page/info.svg",
                          variant: "var(--coming-soon)",
                          buttonNeeded: false,
                        });
                      }}
                      overlay1Icon={overlay.overlay1Icon}
                      overlay1IconColor={overlay.overlay1IconColor}
                    />
                  </div>
                );
              })
            )}
          </div>
        </div>
        <div
          className={`h-pagination-height ${showInnerSearchBar ? "hidden " : " hidden Qsmd:block"} w-width-full `}
        ></div>
      </div>
    </>
  );
};

export default FieldForceTxnRequestSingleApproval;
